import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import AnnouncementBar from './components/AnnouncementBar';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import FloatingWhatsAppButton from './components/FloatingWhatsAppButton';
import HeroSection from './sections/HeroSection';
import ArchitectureSection from './sections/ArchitectureSection';
import WhatsAppSection from './sections/WhatsAppSection';
import ServicesSection from './sections/ServicesSection';
import PackagesSection from './sections/PackagesSection';
import OnboardingSection from './sections/OnboardingSection';
import TestimonialsSection from './sections/TestimonialsSection';
import FAQSection from './sections/FAQSection';
import CTASection from './sections/CTASection';
import LeadModalLuxury from './components/LeadModalLuxury';
import MobileQuoteBar from './components/MobileQuoteBar';

// Bookkeeping navy, cream & orange stylesheet (scoped to .bk-page)
import './bookkeeping.css';

const AuditTaxConsulting = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [presetService, setPresetService] = useState(null);

  // Accepts a click event (header / final CTA) or a service label (package cards)
  const openModal = (arg) => {
    if (arg && arg.preventDefault) arg.preventDefault();
    setPresetService(typeof arg === 'string' ? arg : null);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="bk-page">
      <Helmet>
        <title>Bookkeeping Services in Dubai, Closed by the 10th | Standard Auditing</title>
        <meta
          name="description"
          content="Send receipts on WhatsApp. A named accountant keeps your books, a second one reviews them, and your monthly report lands on the 10th. One fixed fee."
        />
        <link rel="canonical" href="https://audit-tax-consulting.standardauditors.com/" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Standard Auditing" />
        <meta property="og:title" content="Bookkeeping Services in Dubai, Closed by the 10th | Standard Auditing" />
        <meta
          property="og:description"
          content="Fixed monthly fee, quoted after a 15-minute call. No lock-in. Your P&L, balance sheet and VAT position, delivered on the 10th."
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400&display=swap"
        />
      </Helmet>

      {/* Announcement bar and header stay pinned together while scrolling */}
      <div className="bk-topbar">
        <AnnouncementBar onOpenModal={openModal} />
        <SiteHeader onOpenModal={openModal} />
      </div>

      <main className="bk-main">
        <HeroSection />
        <ArchitectureSection onOpenModal={openModal} />
        <WhatsAppSection />
        <ServicesSection />
        <PackagesSection onOpenModal={openModal} />
        <OnboardingSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection onOpenModal={openModal} />
      </main>

      <SiteFooter />

      {/* Lead quote modal (Web3Forms) */}
      <LeadModalLuxury isOpen={isModalOpen} onClose={closeModal} presetService={presetService} />

      {/* Floating WhatsApp Button (desktop) */}
      <FloatingWhatsAppButton />

      {/* Mobile sticky bottom bar: WhatsApp | Fixed quote */}
      <MobileQuoteBar onOpenModal={openModal} />
    </div>
  );
};

export default AuditTaxConsulting;
